import { define } from 'wicked-elements'

define('[data-component="pwa-titlebar"]', {
  init() {
    this.backButton = this.element.querySelector('[data-pwa-back]')
    this.titleElement = this.element.querySelector('[data-pwa-title]')
    this.menuButton = this.element.querySelector('[data-pwa-menu]')

    this.handleMenuClick = this.handleMenuClick.bind(this)
    this.handleBackClick = this.handleBackClick.bind(this)
  },

  connected() {
    if (this.backButton) {
      this.backButton.addEventListener('click', this.handleBackClick)
      this.updateBackButtonState()
    }
    if (this.menuButton) {
      this.menuButton.addEventListener('click', this.handleMenuClick)
    }
    // Listen for navigation changes
    if (window.GPLA_APP) {
      this.backButtonStateListener = window.GPLA_APP.on('after', () => {
        this.updateBackButtonState()
      })
    }
  },

  disconnected() {
    if (this.backButton) {
      this.backButton.removeEventListener('click', this.handleBackClick)
    }
    if (this.menuButton) {
      this.menuButton.removeEventListener('click', this.handleMenuClick)
    }
    if (this.backButtonStateListener && typeof this.backButtonStateListener === 'function') {
      this.backButtonStateListener()
    }
  },
  
  handleBackClick() {
    if (window.history.length > 1) {
      window.history.back()
    }
  },
  
  handleMenuClick() {
    this.showContextMenu()
  },
  
  updateBackButtonState() {
    const canGoBack = window.history.length > 1 && window.location.pathname !== '/'
    
    this.backButton.disabled = !canGoBack
    this.backButton.classList.toggle('opacity-0', !canGoBack)
    this.backButton.classList.toggle('opacity-100', canGoBack)
  },
  
  showContextMenu() {
    // Check if menu is already open and close it
    const existingMenu = document.querySelector('[data-context-menu]')
    if (existingMenu) {
      existingMenu.remove()
      // Remove the click outside listener for the existing menu
      document.removeEventListener('click', this.closeMenuHandler)
      return
    }

    const menu = document.createElement('div')
    menu.className = 'fixed top-16 right-gutter bg-white border border-black rounded-lg py-2.5 pb-2 z-40'
    menu.setAttribute('data-context-menu', '')
    
    const menuItems = [
      { label: 'Info', icon: '/assets/images/pwa/ui_info.svg', href: '/info' },
      { label: 'Settings', icon: '/assets/images/pwa/ui_sliders.svg', href: '/settings' },
      { label: 'Refresh', icon: '/assets/images/pwa/ui_refresh.svg', action: () => window.location.reload() }
    ]
    
    menuItems.forEach(item => {
      const link = document.createElement(item.href ? 'a' : 'button')
      link.className = 'block w-full text-left pl-4 pr-6 py-1 flex items-center gap-2 text-2xl'
      
      if (item.href) {
        link.href = item.href
        link.addEventListener('click', () => {
          menu.remove()
          document.removeEventListener('click', this.closeMenuHandler)
        })
      } else {
        link.addEventListener('click', () => {
          item.action()
          menu.remove()
          document.removeEventListener('click', this.closeMenuHandler)
        })
      }
      
      if (item.icon) {
        const icon = document.createElement('img')
        icon.src = item.icon
        icon.draggable = false
        icon.className = 'w-6 h-6 mr-1.5'
        link.appendChild(icon)
      }
      
      const text = document.createElement('span')
      text.className = 'pt-1'
      text.textContent = item.label
      link.appendChild(text)
      
      menu.appendChild(link)
    })
    
    // Close menu on outside click
    this.closeMenuHandler = (e) => {
      if (!menu.contains(e.target) && !this.menuButton.contains(e.target)) {
        menu.remove()
        document.removeEventListener('click', this.closeMenuHandler)
      }
    }
    
    document.addEventListener('click', this.closeMenuHandler)
    document.body.appendChild(menu)
  }
}) 